export const getSessionStorage = (key: string) => {
  return window.sessionStorage.getItem(key) || ''
}

export const setSessionStorage = (key: string, value: string) => {
  window.sessionStorage.setItem(key, value)
}
